import { getUsers, getUsersAxios } from '@/api/user.js';

export default {
    state: {
        email: null,
        roleName: null,
        permissions: {},
        tokenCreate: null,
        tokenExpiration: null,

        users: [],

        isShowUserEdit: false,
        isSaveEditData: false,
        userEditData: null,

        isShowUserAdd: false,
        isSaveAddData: false,
        userAddData: {
            name: '',
            company: '',
            email: '',
            password: '',
        },

        isShowUserSearch: false,
        userSearchData: {
            id: null,
            email: '',
            is_active: 'all',
            user_role_id: 'all',
            subscription_plan_id: 'all',
        },

        userSortData: {
            sort: 'id:desc',
        },

        // Subscription plans for filter
        subscriptionPlans: [],
        isPlansLoaded: false,

        // User details (loaded async)
        userDetails: null,
        isUserDetailsLoading: false,

        // Pagination state
        userPagination: {
            total: 0,
            limit: 100,
            offset: 0,
            count: 0,
        },
        userPaginationLinks: {
            self: null,
            first: null,
            prev: null,
            next: null,
            last: null,
        },
        isUsersLoading: false,
    },
    getters: {
        USERS: (state) => {
            // Return users in the exact order received from backend
            // Backend handles sorting via 'sort' query parameter
            return state.users;
        },
        USER_PERMISSIONS: (state) => {
            return state.permissions;
        },
        USER_EMAIL: (state) => {
            return state.email;
        },
        USER_ROLE: (state) => {
            return state.roleName;
        },
        USER_TOKEN_TIME: (state) => {
            return {
                create: state.tokenCreate,
                expiration: state.tokenExpiration,
            };
        },
        IS_SHOW_USER_EDIT: (state) => {
            return state.isShowUserEdit;
        },
        IS_SAVE_EDIT_DATA: (state) => {
            return state.isSaveEditData;
        },
        USER_EDIT_DATA: (state) => {
            return state.userEditData;
        },

        IS_SHOW_UDER_ADD: (state) => {
            return state.isShowUserAdd;
        },
        IS_SAVE_ADD_DATA: (state) => {
            return state.isSaveAddData;
        },
        USER_ADD_DATA: (state) => {
            return state.userAddData;
        },

        IS_SHOW_USER_SEARCH: (state) => {
            return state.isShowUserSearch;
        },
        USER_SEARCH: (state) => {
            return state.userSearchData;
        },
        USER_SEARCH_DATA: (state) => {
            return state.userSearchData;
        },

        USER_SORD: (state) => (id) => {
            return state.userSortData[id];
        },

        USER_PAGINATION: (state) => state.userPagination,
        USER_PAGINATION_LINKS: (state) => state.userPaginationLinks,
        IS_USERS_LOADING: (state) => state.isUsersLoading,
        USER_SORT_DATA: (state) => state.userSortData,
        USER_CURRENT_PAGE: (state) => {
            if (state.userPagination.limit === 0) return 1;
            return (
                Math.floor(
                    state.userPagination.offset / state.userPagination.limit
                ) + 1
            );
        },
        USER_TOTAL_PAGES: (state) => {
            if (state.userPagination.limit === 0) return 1;
            return Math.ceil(
                state.userPagination.total / state.userPagination.limit
            );
        },
        SUBSCRIPTION_PLANS: (state) => state.subscriptionPlans,
        IS_PLANS_LOADED: (state) => state.isPlansLoaded,
        USER_DETAILS: (state) => state.userDetails,
        IS_USER_DETAILS_LOADING: (state) => state.isUserDetailsLoading,
    },
    mutations: {
        USERS: (state, payload) => {
            // Store users in exact order received from backend
            state.users = payload;
        },
        USERS_PUSH: (state, payload) => {
            state.users.push(structuredClone(payload));
        },
        SET_USER: (state, payload) => {
            if (payload === null) {
                state.email = null;
                state.roleName = null;
                state.tokenCreate = null;
                state.tokenExpiration = null;
                state.permissions = {};
            } else {
                state.email = payload.sub;
                state.roleName = payload.permissions.name;
                state.tokenCreate = payload.iat;
                state.tokenExpiration = payload.exp;
                state.permissions = payload.permissions;
            }
        },
        USER_EMAIL: (state, payload) => {
            state.email = payload;
        },
        USER_ROLE: (state, payload) => {
            state.roleName = payload;
        },
        USER_TOKEN_CREATE: (state, payload) => {
            state.tokenCreate = payload;
        },
        USER_TOKEN_EXPIRATION: (state, payload) => {
            state.tokenExpiration = payload;
        },
        USER_PERMISSIONS: (state, payload) => {
            state.permissions = payload;
        },
        USER_SET_DATA: (
            state,
            {
                id,
                name = null,
                email = null,
                company = null,
                isActive = null,
                isVerified = null,
                userRoleID = null,
            }
        ) => {
            const userIndex = state.users.map((user) => user.id).indexOf(id);
            if (userIndex < 0) return;

            if (name != null) {
                state.users[userIndex].name = name;
            }
            if (email != null) {
                state.users[userIndex].email = email;
            }
            if (company != null) {
                state.users[userIndex].company = company;
            }
            if (isActive != null) {
                state.users[userIndex].is_active = isActive;
            }
            if (isVerified != null) {
                state.users[userIndex].is_verified = isVerified;
            }
            if (userRoleID != null) {
                state.users[userIndex].user_role_id = userRoleID;
            }
        },
        IS_SHOW_USER_EDIT: (state, payload) => {
            state.isShowUserEdit = payload;
        },
        IS_SAVE_EDIT_DATA: (state, payload) => {
            state.isSaveEditData = payload;
        },
        USER_EDIT_SET: (state, payload) => {
            state.userEditData =
                payload == null ? null : structuredClone(payload);
        },
        USER_EDIT_UPDATE: (
            state,
            {
                name = null,
                company = null,
                roleID = null,
            }
        ) => {
            if (name != null) {
                state.userEditData.name = name;
            }
            if (company != null) {
                state.userEditData.company = company;
            }
            if (roleID != null) {
                state.userEditData.user_role_id = roleID;
            }
        },
        IS_SHOW_UDER_ADD: (state, payload) => {
            state.isShowUserAdd = payload;
        },
        IS_SAVE_ADD_DATA: (state, payload) => {
            state.isSaveAddData = payload;
        },
        USER_ADD_DATA: (
            state,
            { name = null, company = null, email = null, password = null }
        ) => {
            if (name != null) {
                state.userAddData.name = name;
            }
            if (email != null) {
                state.userAddData.email = email;
            }
            if (company != null) {
                state.userAddData.company = company;
            }
            if (password != null) {
                state.userAddData.password = password;
            }
        },

        IS_SHOW_USER_SEARCH: (state, payload) => {
            state.isShowUserSearch = payload;
        },
        USER_SEARCH: (state, payload) => {
            state.userSearchData = payload;
        },
        USER_SEARCH_UPDATE: (state, { fieldName, fieldValue }) => {
            state.userSearchData[fieldName] = fieldValue;
        },

        USER_SORD: (state, { id, payload }) => {
            if (typeof payload !== 'number') return;

            Object.keys(state.userSortData).forEach((sortKey) => {
                state.userSortData[sortKey] = 0;
            });

            if (payload > 2) {
                state.userSortData[id] = 0;
                state.userSortData.currentSort = null;
                return;
            }

            state.userSortData.currentSort = id;
            state.userSortData[id] = payload;
        },

        SET_USER_PAGINATION(state, payload) {
            state.userPagination = payload;
        },
        SET_USER_PAGINATION_LINKS(state, payload) {
            state.userPaginationLinks = payload;
        },
        SET_USERS_LOADING(state, payload) {
            state.isUsersLoading = payload;
        },
        SET_USER_SORT(state, payload) {
            state.userSortData.sort = payload;
        },
        SET_USER_LIMIT(state, payload) {
            state.userPagination.limit = payload;
            state.userPagination.offset = 0; // Reset to first page
        },
        SET_USER_OFFSET(state, payload) {
            state.userPagination.offset = payload;
        },
        RESET_USER_FILTERS(state) {
            state.userSearchData = {
                id: null,
                email: '',
                is_active: 'all',
                user_role_id: 'all',
                subscription_plan_id: 'all',
            };
            state.userPagination.offset = 0; // Reset to first page
        },
        SET_SUBSCRIPTION_PLANS(state, plans) {
            state.subscriptionPlans = plans;
            state.isPlansLoaded = true;
        },
        SET_USER_DETAILS(state, payload) {
            state.userDetails = payload;
        },
        SET_USER_DETAILS_LOADING(state, payload) {
            state.isUserDetailsLoading = payload;
        },
        CLEAR_USER_DETAILS(state) {
            state.userDetails = null;
        },
    },
    actions: {
        DELETE_USER: async function (context) {
            // Clear main user auth data
            context.commit('USER_EMAIL', null);
            context.commit('USER_ROLE', null);
            context.commit('USER_TOKEN_CREATE', null);
            context.commit('USER_TOKEN_EXPIRATION', null);
            context.commit('USER_PERMISSIONS', {});

            // Clear all user-related data to prevent data leakage
            context.commit('USERS', []);
            context.commit('IS_SHOW_USER_EDIT', false);
            context.commit('USER_EDIT_SET', null);
            context.commit('IS_SHOW_UDER_ADD', false);
            context.commit('USER_ADD_DATA', {
                name: '',
                company: '',
                email: '',
                password: '',
            });
            context.commit('IS_SHOW_USER_SEARCH', false);
            context.commit('USER_SEARCH_UPDATE', {
                fieldName: 'id',
                fieldValue: null,
            });
            context.commit('USER_SEARCH_UPDATE', {
                fieldName: 'email',
                fieldValue: null,
            });
            context.commit('USER_SEARCH_UPDATE', {
                fieldName: 'is_active',
                fieldValue: 'all',
            });
            context.commit('USER_SEARCH_UPDATE', {
                fieldName: 'user_role_id',
                fieldValue: 'all',
            });
        },
        async loadUsers({ commit, state }) {
            commit('SET_USERS_LOADING', true);

            try {
                // Build filter params
                const params = {
                    limit: state.userPagination.limit,
                    offset: state.userPagination.offset,
                    sort: state.userSortData.sort,
                };

                // Add filters only if not default
                if (state.userSearchData.id) {
                    params.id = state.userSearchData.id;
                }
                if (state.userSearchData.email) {
                    params.email = state.userSearchData.email;
                }
                if (state.userSearchData.is_active !== 'all') {
                    params.is_active = state.userSearchData.is_active;
                }
                if (state.userSearchData.user_role_id !== 'all') {
                    params.user_role_id = state.userSearchData.user_role_id;
                }
                if (state.userSearchData.subscription_plan_id !== 'all') {
                    params.subscription_plan_id = parseInt(
                        state.userSearchData.subscription_plan_id
                    );
                }

                const response = await getUsers(params);

                commit('USERS', response.data);
                commit('SET_USER_PAGINATION', response.pagination);
                commit('SET_USER_PAGINATION_LINKS', response.links);
            } catch (error) {
                console.error('Error loading users:', error);
                commit('USERS', []);
                commit('SET_USER_PAGINATION', {
                    total: 0,
                    limit: 100,
                    offset: 0,
                    count: 0,
                });
            } finally {
                commit('SET_USERS_LOADING', false);
            }
        },

        async changeUserPage({ commit, dispatch }, pageAction) {
            const state = this.state.user;
            const limit = state.userPagination.limit;
            let newOffset = state.userPagination.offset;

            switch (pageAction) {
                case 'first':
                    newOffset = 0;
                    break;
                case 'prev':
                    newOffset = Math.max(
                        0,
                        state.userPagination.offset - limit
                    );
                    break;
                case 'next':
                    newOffset = Math.min(
                        state.userPagination.total - limit,
                        state.userPagination.offset + limit
                    );
                    break;
                case 'last':
                    newOffset =
                        Math.floor((state.userPagination.total - 1) / limit) *
                        limit;
                    break;
            }

            commit('SET_USER_OFFSET', newOffset);
            await dispatch('loadUsers');
        },
        async loadSubscriptionPlans({ commit }) {
            try {
                const { axiosRequest, METHOD } = await import(
                    '@/api/default.js'
                );
                const constants = (await import('@/constants/index.js'))
                    .default;

                const response = await axiosRequest({
                    url: constants.URL.BILLING_PLANS,
                    method: METHOD.GET,
                    requestName: 'LOAD SUBSCRIPTION PLANS',
                    isLoader: false,
                });

                if (response && response.plans) {
                    const activePlans = response.plans
                        .filter((plan) => plan.is_active)
                        .map((plan) => ({
                            id: plan.id,
                            name: plan.name,
                        }));
                    commit('SET_SUBSCRIPTION_PLANS', activePlans);
                }
            } catch (error) {
                console.error('Failed to load subscription plans:', error);
                commit('SET_SUBSCRIPTION_PLANS', []);
            }
        },
        async loadUserDetails({ commit, getters }) {
            const userId = getters.USER_EDIT_DATA?.id;
            if (!userId) return;

            commit('SET_USER_DETAILS_LOADING', true);
            try {
                const { getUserDetails } = await import('@/api/user.js');
                const details = await getUserDetails(userId);
                commit('SET_USER_DETAILS', details);
            } catch (error) {
                console.error('Failed to load user details:', error);
                commit('SET_USER_DETAILS', null);
            } finally {
                commit('SET_USER_DETAILS_LOADING', false);
            }
        },
        async hardDeleteUser({ commit, dispatch }, userId) {
            const { axiosRequest, METHOD } = await import('@/api/default.js');
            const constants = (await import('@/constants/index.js')).default;

            const response = await axiosRequest({
                url: constants.URL.USER_HARD_DELETE.replace(
                    '{user_id}',
                    userId
                ),
                method: METHOD.POST,
                requestName: 'HARD DELETE USER',
                isLoader: true,
                isShowPopup: false,
                skipAuth: false,
                skipErrorPopup: false,
            });

            if (response && response.success) {
                dispatch('loadUsers');
                commit('IS_SHOW_USER_EDIT', false);
                commit('SET_USER_EDIT_DATA', null);

                return response;
            }

            return null;
        },
        CHECK_USERS: async function (context) {
            if (context.getters.USERS.length === 0) {
                await context.dispatch('UPDATE_USERS');
            }
        },
        CHECK_USERS_AXIOS: async function (context) {
            if (context.getters.USERS.length === 0) {
                const params = await readParams(
                    context.getters.USER_SEARCH_DATA
                );
                const axiosPromise = await getUsersAxios(params).catch(
                    (error) => {
                        return null;
                    }
                );
                return axiosPromise;
            }
            return null;
        },
        UPDATE_USERS: async function (context) {
            const params = await readParams(context.getters.USER_SEARCH_DATA);
            context.commit('USERS', await getUsers(params));
        },
        CHECK_USER_EDIT: async function (context) {
            const editData = context.getters.USER_EDIT_DATA;
            if (editData.name === '' || editData.name == null) {
                context.commit('IS_SAVE_EDIT_DATA', false);
                return 'To save the user, fill in all the fields';
            }
            if (editData.company === '' || editData.company == null) {
                context.commit('IS_SAVE_EDIT_DATA', false);
                return 'To save the user, fill in all the fields';
            }

            context.commit('IS_SAVE_EDIT_DATA', true);
            return '';
        },
        CHECK_USER_ADD: async function (context) {
            const addData = context.getters.USER_ADD_DATA;
            const regexMail = /[^@]+@[^@]+\.[^@]+/;

            if (addData.name === '' || addData.name == null) {
                context.commit('IS_SAVE_ADD_DATA', false);
                return 'To register a user, fill in all the fields';
            }
            if (addData.company === '' || addData.company == null) {
                context.commit('IS_SAVE_ADD_DATA', false);
                return 'To register a user, fill in all the fields';
            }
            if (addData.password === '' || addData.password == null) {
                context.commit('IS_SAVE_ADD_DATA', false);
                return 'To register a user, fill in all the fields';
            }
            if (addData.email === '' || addData.email == null) {
                context.commit('IS_SAVE_ADD_DATA', false);
                return 'To register a user, fill in all the fields';
            } else if (regexMail.test(addData.email) === false) {
                context.commit('IS_SAVE_ADD_DATA', false);
                return 'The email address is specified in the wrong format';
            }

            context.commit('IS_SAVE_ADD_DATA', true);
            return '';
        },
    },
};

async function readParams({ id, email, is_active, user_role_id }) {
    let params = {};

    if (id != null) params['id'] = id;
    if (email != null) params['email'] = email;
    if (is_active !== 'all') params['is_active'] = is_active;
    if (user_role_id !== 'all') params['user_role_id'] = user_role_id;

    return params;
}
